<template>
    <div class="bt">
        <div class="bottom">
            <div class="line"></div>
            <img :class="isMobile==0?'':'logo_img_mobile'" class="logo_img" src="../assets/logo.png"></img>
            <div class="line"></div>
        </div>
        <div :class="isMobile==0?'':'text_mobile'" class="text" v-if="ifShow">
            <div v-if="isMobile==0" style="margin-right: 60px;">
                Telephone: +86 021 69152333
            </div>
            <div v-if="isMobile==1" style="margin-bottom: 10px;">
                Telephone: +86 021 69152333
            </div>
            <div>
                E-mail: CHOISIVIP@163.COM
            </div>
        </div>
        <!-- <a style="text-align: center;color: white;font-size: 20x;margin-left: 45.5%;" href="https://beian.miit.gov.cn">沪ICP备2025145205号</a> -->
    </div>
</template>

<script>
export default {
    name: 'Bottom',
    props: {
        ifShow: Boolean
    },
    data() {
        return {

            isMobile: 0
        }
    }, mounted() {
        this.isMobile = localStorage.getItem('isMobile')
    },
}
</script>

<style>
.bt {
    box-sizing: border-box;
    background: #6488C6;
    padding: 20px;
}

.bottom {
    display: flex;
    justify-content: center;
    align-items: center;
}

.line {
    width: 70%;
    height: 1px;
    border-top: 1px solid #FFFFFF;
}

.logo_img {
    margin: 0px 40px;
    width: 75px;
    height: 70px;
}
.logo_img_mobile{ margin: 0px 20px;
    width: 45px;
    height: 43px;
}
.text {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px auto 20px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
}
.text_mobile{
    flex-direction: column;
}
</style>